import React from 'react';
import { NoResultComponent } from '@yme/molecules/no-results-component';
import { useTranslation } from '@yme/services/i18n';
import { getNoResultDescription } from './helpers';
import { HeadingLevel2Styled, NoResultsWrapperStyled } from './styled';
export function NoResultsSearch({ value, isHeaderNeeded = false }) {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        isHeaderNeeded && value && (React.createElement(HeadingLevel2Styled, null, getNoResultDescription(t('globalSearch_noResults_header'), value))),
        React.createElement(NoResultsWrapperStyled, { padding: "24px", gap: "12px", flexDirection: "column", alignItems: "center", isFullWidth: true },
            React.createElement(NoResultComponent, { noResultTitle: t('globalSearch_noResults_title'), noResultDescription: value ? getNoResultDescription(t('globalSearch_noResults_message'), value) : '' }))));
}
